import React from 'react'
import { Formik } from 'formik'
import { CircularProgress } from '@material-ui/core'
import { TextFieldIcon, SelectFieldIcon, Button, PhoneFieldIcon, TopBar } from '../_components'
import NITALogo from '../_images/nita_logo.svg'
import data from '../fixtures'
import { FaPhoneAlt, FaHospitalUser, FaBuilding, FaIdBadge, FaPager, FaAddressCard, FaServer, FaThLarge, FaWindowMaximize, FaRegBuilding, FaRegWindowMaximize, FaRegListAlt, FaUserCircle, FaWarehouse, FaIdCard, FaTable, FaIndent, FaUserAlt, FaLock } from 'react-icons/fa'
import Axios from 'axios'
// import { Footer } from './SignIn'
import { createReferenceID } from '../_utils'

export default function RegistrationForm() {
  const [ signing, setSigning ] = React.useState( false )
  const [ phone, setPhone ] = React.useState( "" )

  const handleSubmit = async( values ) => {
    try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcouser`, {
            applicant: values.applicant,
            district: values.district,
            region: values.region,
            phone_number: phone,
            first_name: values.first_name,
            last_name: values.last_name,
            user_role: "APPLICANT",
            username: values.email_address,
            email_address: values.email_address,
            status: "REGISTERED",
            domain: values.domain,
            referenceID: createReferenceID( 10 )
        } ) 
        if( response.data.success === true  ) {
           await  dispatchEmailNotification( {
                email: values.email_address
            } )
            alert( "Registration successful. Credentials sent your Email." )
            await localStorage.setItem( "link", "home" )
            return window.location.reload()
        }  else{
            alert(response.data.message)
            //console.log(response.data)
        } 
    } catch (error) {
        alert( "Server error occurred. Please try again later." ) 
    }
  }

  const dispatchEmailNotification = async ( payload ) => {
    try {
        /* await Axios.post( `https://mis.nec.go.ug/mis/api/initiate_email/`, {
            "recipient": payload.email,
            "email_body": `Your username is ${payload.email} and your password is admin1234. You are required to modify the password after first time login.`,
            "subject": "RE: IT Certification Office"
        } ) */
    } catch (error) {
        
    }
  }

  return (
    <div className="w-screen h-screen overflow-x:hidden overflow-y-scroll sm:overflow-y-scroll md:overflow-y-scroll lg:overflow-y-scroll bg-gray-100 relative">
       <TopBar home />
       <div className="w-full h-auto flex items-start justify-center my-5">
        <div className= "p-12 lg:w-1/2 md:w-1/2 sm:w-full w-full h-auto bg-white rounded-sm shadow-xl relative">
          <div className="flex flex-col items-center justify-center">
            <img src={NITALogo} alt="ITCO Logo" className="h-16" />
            <h2 className="border-b border-gray-300 font-bold px-2 py-1 md:text-base lg:text-base text-sm">
              {`Account Creation`}
            </h2>
          </div>
          <Formik initialValues={{
                applicant: "",
                domain: "",
                email_address: "",
                password: "",
                repeat_password: "",
                phone_number: "",
                country: "Uganda",
                region: "",
                district: ""
            }} onSubmit={handleSubmit}>
              { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                  return (
                      <form onSubmit={handleSubmit}>
                        <div className="w-full py-2 grid grid-cols-1 md:grid-cols-2 md:gap-2 lg:grid-cols-2 lg:gap-2">
                            <TextFieldIcon 
                                name="applicant"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.applicant}
                                iconComponent={<FaUserAlt color={`#AFC836`} />} 
                                label="Client Name"
                                required={true}
                                disabled={signing}
                                question="Client Name" />
                            
                            {values.category === "Other" && (
                                <TextFieldIcon 
                                name="other_category"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.other_category}
                                iconComponent={<FaUserAlt color={`#AFC836`} />} 
                                label="Other"
                                required={false}
                                disabled={signing}
                                question="Specify Other" />
                            )}

                        <SelectFieldIcon 
                            name="domain"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.domain}
                            iconComponent={<FaPager color={`#AFC836`} />} 
                            label="IT Domain"
                            required={true}
                            disabled={signing}
                            options={[
                            { id: 1, value: "ITSP", label: "IT Service Provider" },
                            { id: 2, value: "ITTI", label: "IT Training Institution(s)" },
                            { id: 3, value: "ET", label: "E-Transaction" },
                            // { id: 4, value: "IITSP", label: "Individual IT Service Provider( Consultant )" },
                            { id: 5, value: "ITProduct", label: "IT Products" },
                            ]}
                            question="Choose IT Domain Certification" />
                        
                       {/*  <TextFieldIcon 
                            name="password"
                            type="password"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.password}
                            iconComponent={<FaLock color={`#AFC836`} />} 
                            label="Password"
                            required={true}
                            disabled={signing}
                            question="Password" />
                        
                        <TextFieldIcon 
                            name="repeat_password"
                            type="password"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.repeat_password}
                            iconComponent={<FaLock color={`#AFC836`} />} 
                            label="Password"
                            required={true}
                            disabled={signing}
                            question="Repeat Password" /> */}
                        
                        <TextFieldIcon 
                            name="email_address"
                            type="email"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.email_address}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Email Address"
                            required={true}
                            disabled={signing}
                            question="Email Address" />

                        <PhoneFieldIcon 
                            name="phone_number"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            callback={ ( phone ) => {
                                setPhone( phone )
                            } }
                            question="Phone Number"
                            required={true}
                        />

                        <SelectFieldIcon
                            name="country"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.country}
                            iconComponent={<FaPager color={`#AFC836`} />} 
                            label="Country"
                            required={true}
                            disabled={signing}
                            options={data.nations.map( country => {
                                return { 
                                    id: country.id, 
                                    value: country.en_short_name, 
                                    label: country.en_short_name 
                                }
                            } )}
                            question="Country" />
                        { values.country === "Uganda" && ( <>
                        <SelectFieldIcon
                            name="region"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.region}
                            iconComponent={<FaPager color={`#AFC836`} />} 
                            label="Region"
                            required={true}
                            disabled={signing}
                            options={data.regions.map( region => {
                                return { 
                                    id: region.id, 
                                    value: region.name, 
                                    label: region.name 
                                }
                            } )}
                            question="Region" />

                        <SelectFieldIcon
                            name="district"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.district}
                            iconComponent={<FaPager color={`#AFC836`} />} 
                            label="District"
                            required={true}
                            disabled={signing}
                            options={data.districts.filter( item => {
                                return item.region_name === values.region
                            } ).map( district => { 
                                return {
                                    id: district.id,
                                    value: district.name,
                                    label: district.name
                                }
                            } )}
                            question="District" />
                          </> ) }
                        </div>

                        <div className="w-full py-2 grid grid-cols-1">
                            {signing ? (
                            <div className="flex items-center justify-center">
                                <CircularProgress size={24} color="primary" />
                            </div>
                            ):
                            ( <Button 
                                type="submit"
                                loading={isSubmitting} 
                                disabled={isSubmitting ? true : false} 
                                label={"Submit"} /> )
                            }
                        </div>
                      </form>
                  )
              }  }
          </Formik>
        </div>
       </div>
      <div>   
     </div>
    </div>
  )
}
